import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Switch,
} from '@chakra-ui/react';
import { SingleDatepicker } from 'chakra-dayzed-datepicker';
import { startOfDay } from 'date-fns';
import { useState } from 'react';
import { LeagueEvent, Team } from '../../types';

interface GenerateBracketModalProps {
  isOpen: boolean;
  onClose: () => void;
  eventId: number;
  league: LeagueEvent;
  teams: Team[];
  onSubmit: (numSeeds: number, persist: boolean, date: Date) => void;
}

export const GenerateBracketModal: React.FC<GenerateBracketModalProps> = ({
  isOpen,
  onClose,
  eventId,
  league,
  teams,
  onSubmit,
}) => {
  const [numSeeds, setNumSeeds] = useState(teams.length / 2);
  const [date, setDate] = useState<Date>(new Date());
  const [persist, setPersist] = useState(true);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Generate Bracket
          <FormControl display="flex" alignItems="center">
            <FormLabel mb="0">Persist?</FormLabel>
            <Switch
              isChecked={persist}
              onChange={(e) => setPersist(e.target.checked)}
              id="persist"
            />
          </FormControl>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl key={league.id}>
            <FormLabel>Num. Seeds {league.name}:</FormLabel>
            <NumberInput
              value={numSeeds}
              onChange={(val) => setNumSeeds(parseInt(val))}
              size="sm"
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
          <FormControl>
            <FormLabel>Date</FormLabel>
            <SingleDatepicker
              date={date}
              onDateChange={(d) => setDate(startOfDay(d))}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button variant="ghost" onClick={onClose}>
              Close
            </Button>
            <Button onClick={() => onSubmit(numSeeds, persist, date)}>
              Generate
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
